export interface ImageSize {
  width: number;
  height: number;
}

export const NO_IMAGE_SIZE: ImageSize = { width: 0, height: 0 };

/**
 * Display size for an image of known intrinsic dimensions: as large as fits
 * within `bounds` at its own aspect ratio, but never upscaled past its own size.
 */
export const fitWithinBounds = (
  intrinsicWidth: number,
  intrinsicHeight: number,
  bounds: ImageSize
): ImageSize => {
  const scale = Math.min(bounds.width / intrinsicWidth, bounds.height / intrinsicHeight, 1);

  return {
    width: Math.round(intrinsicWidth * scale),
    height: Math.round(intrinsicHeight * scale),
  };
};

export const hasIntrinsicSize = (intrinsicSize?: ImageSize): boolean =>
  !!intrinsicSize && intrinsicSize.width > 0 && intrinsicSize.height > 0;
